import React from 'react'
import { Tooltip } from '../Tooltip'

export const storybookTooltip = (text: string, id?: string) => (
  <Tooltip.Content id={id} placement="top" style={{ zIndex: 10 }}>
    {text}
  </Tooltip.Content>
)
